import FinancePlatform, { DialogHost } from './FinancePlatform';
import Login from './components/Login';
import SetNewPassword from './components/SetNewPassword';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider, useAuth } from './lib/AuthContext';

function Gate() {
  const { session, loading, recoveryMode } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Loading…
      </div>
    );
  }

  // Password-recovery flow takes priority over the normal app — the user
  // came in via an email reset link.
  if (recoveryMode) return <SetNewPassword />;
  if (!session)     return <Login />;

  return <FinancePlatform />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Gate />
        <DialogHost />
      </AuthProvider>
    </ErrorBoundary>
  );
}
